import { useTheme } from "@mui/material"
import { Chip } from "@pharmupp/p3-front-commons"

export const EventCancelledChip = () => {
  const { palette, typography } = useTheme()

  return (
    <Chip
      label="événement annulé"
      size="small"
      fontColor={palette.common.white}
      backgroundColor={palette.common.red}
      sx={{ fontSize: typography.pxToRem(9.6), textTransform: "uppercase" }}
    />
  )
}
